var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/init-masonry-registry.ts
import { MasonryDriverNodeRenderersRegistry } from "@leagueplatform/masonry";
import { DEFAULT_NAMESPACE } from "@leagueplatform/masonry-engine";

// src/components/get-care-service-card/get-care-service-card.component.tsx
import * as React2 from "react";
import { Box as Box2, Card as Card2 } from "@leagueplatform/genesis-core";
import {
  DismissButton
} from "@leagueplatform/masonry-renderers";

// src/components/get-care-service-card/get-care-service-card-content.component.tsx
import React from "react";
import { uniqueId } from "lodash";
import {
  ParagraphText,
  StackLayout,
  HeadingText,
  UtilityText,
  Box,
  TextAction,
  Card
} from "@leagueplatform/genesis-core";
import { useInvokeAction } from "@leagueplatform/masonry";
import { InternalOrExternalLinkButton } from "@leagueplatform/web-common-components";
import {
  BadgeList,
  getTextActionIndicatorIconToken
} from "@leagueplatform/masonry-renderers";
import { useIntl } from "@leagueplatform/locales";
var BodyTextHtmlTagOptions = {
  a: {
    component: InternalOrExternalLinkButton,
    props: {
      baseComponent: TextAction,
      // Stop event propagation to prevent triggering on card click event on click of link inside paragraph text
      onClick: (e) => e.stopPropagation()
    }
  }
};
var GetCareServiceCardContent = ({
  eyebrow,
  heading,
  body,
  badges,
  badgeBackgroundColor,
  onClick,
  ctaLabel,
  ctaIndicator: _ctaIndicator,
  isCtaLabelledByHeading
}) => {
  var _a;
  const { formatMessage } = useIntl();
  const eyebrowId = `get-care-service-card-${heading == null ? void 0 : heading.replace(/\s+/g, "-")}`;
  const headingId = React.useMemo(
    () => uniqueId("GetCareServiceCardContent"),
    []
  );
  const ctaId = `${headingId}-cta`;
  const ctaLabelledById = `${ctaId} ${headingId}`;
  const ctaIndicator = _ctaIndicator ? getTextActionIndicatorIconToken(_ctaIndicator) : void 0;
  const invokeAction = useInvokeAction();
  const handleOnClick = React.useCallback(
    (event) => {
      if (onClick) {
        invokeAction(__spreadValues({
          event
        }, onClick));
      }
    },
    [invokeAction, onClick]
  );
  return /* @__PURE__ */ React.createElement(Box, { css: { display: "flex", flexDirection: "column", height: "100%" } }, /* @__PURE__ */ React.createElement(Card.Section, null, /* @__PURE__ */ React.createElement(StackLayout, { spacing: "$threeQuarters", orientation: "vertical" }, /* @__PURE__ */ React.createElement(StackLayout, { spacing: "$half", orientation: "vertical" }, eyebrow && /* @__PURE__ */ React.createElement(UtilityText, { id: eyebrowId, size: "eyebrow", as: "p" }, eyebrow), heading && /* @__PURE__ */ React.createElement(
    HeadingText,
    {
      id: isCtaLabelledByHeading ? headingId : void 0,
      level: "3",
      size: "md",
      "aria-describedby": eyebrowId
    },
    heading
  ), body && /* @__PURE__ */ React.createElement(
    ParagraphText,
    {
      htmlStringOptions: BodyTextHtmlTagOptions,
      emphasis: "subtle"
    },
    body
  )), badges && /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(
    BadgeList,
    {
      badges,
      backgroundColor: badgeBackgroundColor
    }
  )))), onClick && /* @__PURE__ */ React.createElement(
    Card.Section,
    {
      css: {
        flexGrow: 0,
        borderTopWidth: "$card",
        borderTopColor: "$onSurfaceBorderSubdued",
        borderTopStyle: "solid"
      }
    },
    /* @__PURE__ */ React.createElement(
      TextAction,
      {
        as: InternalOrExternalLinkButton,
        baseComponent: TextAction,
        href: (_a = onClick == null ? void 0 : onClick.payload.url) != null ? _a : "",
        onClick: handleOnClick,
        id: isCtaLabelledByHeading ? ctaId : void 0,
        "aria-labelledby": isCtaLabelledByHeading ? ctaLabelledById : void 0,
        icon: "interfaceCTAIndicator",
        indicator: ctaIndicator,
        size: "medium",
        disableDefaultOnClick: true,
        css: {
          fontWeight: "$bodyOne",
          color: "$onSurfaceTextPrimary",
          fontSize: "$bodyOne",
          ".GDS-icon": {
            color: "$primaryBackgroundDefault"
          },
          "&:hover": {
            textDecoration: "none",
            ".GDS-icon": {
              color: "$primaryBackgroundHovered"
            }
          }
        }
      },
      ctaLabel != null ? ctaLabel : formatMessage({ id: "GET_CARE_SERVICE_CARD_CTA" })
    )
  ));
};

// src/components/get-care-service-card/get-care-service-card.component.tsx
function GetCareServiceCardRenderer(_a) {
  var _b = _a, {
    isChildItem,
    image,
    imageAltText,
    showMobile,
    onDismiss
  } = _b, props = __objRest(_b, [
    "isChildItem",
    "image",
    "imageAltText",
    "showMobile",
    "onDismiss"
  ]);
  const showSmallerCard = isChildItem || showMobile;
  return /* @__PURE__ */ React2.createElement(
    Card2.Flat,
    {
      imagePosition: showSmallerCard ? "top" : {
        "@initial": "end",
        "@mobile": "top"
      },
      backgroundColor: "secondary",
      css: {
        height: showSmallerCard ? "100%" : "auto",
        borderWidth: "$card",
        borderColor: "$onSurfaceBorderSubdued",
        borderStyle: "solid",
        borderRadius: "$card"
      }
    },
    onDismiss && /* @__PURE__ */ React2.createElement(
      DismissButton,
      {
        onDismiss,
        toolbarButton: true,
        css: {
          position: "absolute",
          insetBlockStart: "$half",
          insetInlineEnd: "$half",
          zIndex: 2
        }
      }
    ),
    image && /* @__PURE__ */ React2.createElement(
      Card2.Image,
      {
        image,
        imageAlt: imageAltText,
        css: { "@mobile": { height: "176px" } }
      }
    ),
    /* @__PURE__ */ React2.createElement(Box2, { css: { flexGrow: 1 } }, /* @__PURE__ */ React2.createElement(
      GetCareServiceCardContent,
      __spreadValues({}, props)
    ))
  );
}

// src/components/layout-box-renderer/layout-box-renderer.component.tsx
import * as React3 from "react";
import { Box as Box3 } from "@leagueplatform/genesis-core";
var NODE_TYPE_LAYOUT_BOX_RENDERER = "boxLayout";
var LayoutBoxRenderer = ({
  backgroundColor = "$surfaceBackgroundPrimary",
  items
}) => {
  if (!items || !items.length)
    return null;
  return /* @__PURE__ */ React3.createElement(
    Box3,
    {
      css: {
        backgroundColor,
        height: "min-content",
        padding: "$oneAndHalf",
        overflowX: "hidden",
        width: "100%"
      },
      id: "care_box_renderer"
    },
    items
  );
};

// src/init-masonry-registry.ts
var NAMESPACE_CARE_DISCOVERY = "care_discovery";
var initMasonryRegistry = () => {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    NAMESPACE_CARE_DISCOVERY,
    "largeCard",
    GetCareServiceCardRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    DEFAULT_NAMESPACE,
    NODE_TYPE_LAYOUT_BOX_RENDERER,
    LayoutBoxRenderer
  );
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import careAdvisorImage from "./assets/care-advisor.svg";
var CARE_DISCOVERY_ASSETS_MAP = {
  CARE_ADVISOR_IMAGE: careAdvisorImage
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(CARE_DISCOVERY_ASSETS_MAP);
};

// src/components/get-care-triage/get-care-triage.component.tsx
import React7, { forwardRef } from "react";
import { LinkLegacy as Link3 } from "@leagueplatform/routing";
import { Box as Box6, QuietButton } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { Modal } from "@leagueplatform/ui-kit";
import { Icon as Icon2 } from "@leagueplatform/genesis-core";
import {
  SkeletonBox,
  SkeletonCards
} from "@leagueplatform/web-common-components";
import { sendAnalyticsEvent as sendAnalyticsEvent3 } from "@leagueplatform/analytics";

// src/components/triage-screen/triage-screen.component.tsx
import React5 from "react";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import {
  Flex,
  Box as Box4,
  HeadingTwo,
  SubtitleOne,
  SubtleButton,
  Text,
  Link
} from "@leagueplatform/genesis-commons";
import { sendAnalyticsEvent } from "@leagueplatform/analytics";
import { isAbsoluteUrl } from "@leagueplatform/web-common";

// src/hooks/use-modal-param.hook.js
import { useUrlParam } from "@leagueplatform/web-common";
var useModalParam = () => {
  const { urlParam, matchParamPath, setParam, removeParam, linkToParam } = useUrlParam("modal");
  return {
    modalParam: urlParam,
    matchModalPath: matchParamPath,
    openModalToPath: setParam,
    closeModal: removeParam,
    linkToModalParam: linkToParam
  };
};

// src/utils/quick-action-icons.util.jsx
import React4 from "react";
var QUICK_ACTION_ICONS = {
  question_claims: /* @__PURE__ */ React4.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React4.createElement(
    "g",
    {
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#501CD2",
      strokeWidth: "1.5"
    },
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        d: "M12.5 21.5H5c-.552285 0-1-.447715-1-1V3c0-.552285.447715-1 1-1h11.129c.397547.000085.778802.157982 1.06.439l2.872 2.872c.281018.281198.438915.662453.439 1.06V20.5c0 .552285-.447715 1-1 1h-7z",
        fill: "#E5DDF9"
      }
    ),
    /* @__PURE__ */ React4.createElement("path", { d: "M13.799852 6.002344h-2.103546c-.242433-.01721-.481163.060964-.653135.213875-.171971.152912-.25989.365181-.240534.580744 0 .871016 2.997215 1.53727 2.997215 2.408286.004381.211916-.088365.416303-.25692.566175-.168555.149873-.398418.23234-.63675.228444h-2.103545M12.3 6V5m0 6v-1m-5.116667 4.316667H17.05M7.183333 18h6.933334" })
  )),
  question_coverage: /* @__PURE__ */ React4.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React4.createElement(
    "g",
    {
      stroke: "#501CD2",
      strokeWidth: "1.5",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        d: "M22.3125 13.375c0-5.695436-4.617064-10.3125-10.3125-10.3125S1.6875 7.679564 1.6875 13.375l.743417-.619667c.890653-.742152 2.042494-1.094662 3.195951-.978092 1.153457.11657 2.211478.692412 2.935632 1.597759.911288-.912424 2.147941-1.425114 3.4375-1.425114 1.289559 0 2.526212.51269 3.4375 1.425114.724154-.905347 1.782175-1.48119 2.935632-1.59776 1.153457-.11657 2.305298.235941 3.195951.978093l.743417.619667z",
        fill: "#E5DDF9"
      }
    ),
    /* @__PURE__ */ React4.createElement("path", { d: "M12 11.951417v8.983333c0 .759391-.615609 1.375-1.375 1.375-.759392 0-1.375-.615609-1.375-1.375M12 3.0625v-1.375" }),
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        d: "M21.526859 16.488034C21.227955 16.176376 20.81359 16 20.380306 16c-.433285 0-.84765.176376-1.146553.488034l-.98276 1.005429-.98276-1.005429C16.96933 16.176376 16.554965 16 16.12168 16c-.433284 0-.84765.176376-1.146553.488034-.633503.659297-.633503 1.696917 0 2.356214l2.926607 3.007174c.091079.094886.21729.148578.34926.148578.131967 0 .25818-.053692.349258-.148578l2.926607-3.011315c.630855-.658749.630855-1.693324 0-2.352073z",
        fill: "#E5DDF9"
      }
    )
  )),
  question_provider: /* @__PURE__ */ React4.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React4.createElement(
    "g",
    {
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#501CD2",
      strokeWidth: "1.5"
    },
    /* @__PURE__ */ React4.createElement("g", { transform: "translate(2 2)" }, /* @__PURE__ */ React4.createElement("circle", { fill: "#E5DDF9", cx: "8.333333", cy: "8.333333", r: "8.333333" }), /* @__PURE__ */ React4.createElement("path", { d: "M20 20l-5.773333-5.773333" })),
    /* @__PURE__ */ React4.createElement("path", { d: "M8 10.5h5M10.5 8v5" })
  )),
  question_health: /* @__PURE__ */ React4.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React4.createElement(
    "g",
    {
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#501CD2",
      strokeWidth: "1.5"
    },
    /* @__PURE__ */ React4.createElement(
      "path",
      {
        d: "M2.5 13.5V5c0-1.656854 1.343146-3 3-3h13c1.656854 0 3 1.343146 3 3v8.5c0 1.656854-1.343146 3-3 3h-2V22l-6-5.5h-5c-1.656854 0-3-1.343146-3-3z",
        fill: "#E5DDF9"
      }
    ),
    /* @__PURE__ */ React4.createElement("path", { d: "M15.276859 6.988034C14.977955 6.676376 14.56359 6.5 14.130306 6.5c-.433285 0-.84765.176376-1.146553.488034l-.98276 1.005428-.98276-1.005428C10.71933 6.676376 10.304965 6.5 9.87168 6.5c-.433284 0-.84765.176376-1.146553.488034-.633503.659297-.633503 1.696917 0 2.356214l2.926607 3.007174c.091079.094886.21729.148578.34926.148578.131967 0 .25818-.053692.349258-.148578l2.926607-3.011315c.630855-.658749.630855-1.693324 0-2.352073z" })
  )),
  chat_blurple: /* @__PURE__ */ React4.createElement("svg", { width: "24", height: "24", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React4.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React4.createElement("path", { d: "M0 0h28v28H0z" }), /* @__PURE__ */ React4.createElement(
    "path",
    {
      d: "M4.5 16.5V8c0-1.656854 1.343146-3 3-3h13c1.656854 0 3 1.343146 3 3v8.5c0 1.656854-1.343146 3-3 3h-2V25l-6-5.5h-5c-1.656854 0-3-1.343146-3-3zM19 10H9m10 4.5H9",
      stroke: "#501cd2",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )))
};
var getQuickActionIcon = (iconId) => {
  var _a;
  return (_a = QUICK_ACTION_ICONS[iconId]) != null ? _a : QUICK_ACTION_ICONS.question_health;
};

// src/components/triage-screen/triage-screen.component.tsx
var QuickAction = ({
  children,
  href,
  target = "_self"
}) => /* @__PURE__ */ React5.createElement(
  Flex,
  {
    as: "a",
    href,
    target,
    rel: target === "_blank" ? "noopener noreferrer" : void 0,
    textDecoration: "none",
    borderRadius: "medium",
    padding: "threeQuarters",
    paddingTop: "oneAndHalf",
    paddingInlineEnd: "one",
    backgroundColor: "highlight.background.subdued",
    flexDirection: "column",
    justifyContent: "flex-end",
    cursor: "pointer",
    width: "100%",
    focusStyle: {
      outline: 0,
      boxShadow: "focusRing"
    },
    onClick: () => {
      sendAnalyticsEvent({
        category: "Quick Action Menu",
        action: "Select Quick Action",
        label: children
      });
    }
  },
  /* @__PURE__ */ React5.createElement(SubtitleOne, { as: "span" }, children)
);
var TopicLink = ({ id, children, icon, url }) => {
  const { linkToModalParam } = useModalParam();
  const isExternalLink = isAbsoluteUrl(url);
  const returnInternalUrl = (path) => path || linkToModalParam(`get-care/${id}`);
  return /* @__PURE__ */ React5.createElement(
    SubtleButton,
    {
      textDecoration: "none",
      color: "onSurface.text.primary",
      borderColor: "interactive.border.disabled",
      paddingY: "oneAndHalf",
      boxShadow: "card",
      marginTop: "one",
      width: "100%",
      justifyContent: "start",
      as: isExternalLink ? Link : RouterLink,
      href: isExternalLink ? url : void 0,
      target: isExternalLink ? "_blank" : void 0,
      rel: isExternalLink ? "noopener noreferrer" : void 0,
      to: !isExternalLink ? returnInternalUrl(url) : void 0,
      onClick: () => {
        sendAnalyticsEvent({
          category: "Quick Action Menu",
          action: "Select Question",
          label: children
        });
      }
    },
    icon,
    /* @__PURE__ */ React5.createElement(Text, { as: "span", marginInlineStart: "one" }, children)
  );
};
var TriageScreen = ({
  actionItems = [],
  menuItems = []
}) => {
  const { formatMessage } = useIntl2();
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(HeadingTwo, { as: "h1", marginBottom: "oneAndHalf" }, formatMessage({ id: "ID_LIKE_TO_DOTDOTDOT" })), Boolean(actionItems.length) && /* @__PURE__ */ React5.createElement(
    Flex,
    {
      as: "ul",
      marginInlineEnd: "minusOne",
      marginBottom: "three",
      justifyContent: "space-between"
    },
    actionItems.map(({ id, url, title, isExternal }) => /* @__PURE__ */ React5.createElement(Flex, { key: id, as: "li", width: 1 / 3, paddingInlineEnd: "one" }, /* @__PURE__ */ React5.createElement(QuickAction, { href: url, target: isExternal ? "_blank" : "_self" }, title)))
  ), /* @__PURE__ */ React5.createElement(Box4, { as: "ul" }, menuItems.map(({ id, title, iconId, url }) => /* @__PURE__ */ React5.createElement("li", { key: id }, /* @__PURE__ */ React5.createElement(TopicLink, { id, icon: getQuickActionIcon(iconId), url }, title)))));
};

// src/components/topic-screen/topic-screen.component.tsx
import React6 from "react";
import { LinkLegacy as RouterLink2 } from "@leagueplatform/routing";
import {
  useTheme,
  Box as Box5,
  HeadingTwo as HeadingTwo2,
  SubtitleOne as SubtitleOne2,
  BodyTwo,
  PrimaryButton,
  SubtleButton as SubtleButton2,
  Link as Link2
} from "@leagueplatform/genesis-commons";
import { Icon, ICONS } from "@leagueplatform/ui-kit";
import { isAbsoluteUrl as isAbsoluteUrl2 } from "@leagueplatform/web-common";
import { sendAnalyticsEvent as sendAnalyticsEvent2 } from "@leagueplatform/analytics";
var TopicItemLink = ({
  isExternalLink,
  url,
  onClick,
  itemTitle
}) => {
  const { space } = useTheme();
  return /* @__PURE__ */ React6.createElement(
    SubtleButton2,
    {
      color: "onSurface.text.primary",
      textDecoration: "none",
      borderWidth: "none",
      borderColor: "interactive.border.disabled",
      borderBottomWidth: "thin",
      borderRadius: "none",
      paddingX: "none",
      width: "100%",
      justifyContent: "space-between",
      as: isExternalLink ? Link2 : RouterLink2,
      href: isExternalLink ? url : void 0,
      target: isExternalLink ? "_blank" : void 0,
      rel: isExternalLink ? "noopener noreferrer" : void 0,
      to: !isExternalLink ? url : void 0,
      onClick
    },
    /* @__PURE__ */ React6.createElement("span", null, itemTitle),
    /* @__PURE__ */ React6.createElement(
      Icon,
      {
        icon: ICONS.FORWARD_CHEVRON,
        size: space.one,
        stroke: "currentColor"
      }
    )
  );
};
var TopicScreen = ({
  topic,
  parentTopicId,
  title,
  disclaimer,
  menuItems = [],
  footerText,
  footerActionText,
  footerUrl
}) => {
  const { linkToModalParam } = useModalParam();
  const getLinkToModalParam = (id) => {
    if (parentTopicId) {
      return linkToModalParam(`get-care/${parentTopicId}/${id}`);
    }
    return linkToModalParam(`get-care/${id}`);
  };
  const dispatchTopicItemAnalytics = (itemTitle) => {
    sendAnalyticsEvent2({
      category: "Quick Action Detail",
      action: "Select Question",
      label: `${topic} - ${itemTitle}`
    });
  };
  return /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(HeadingTwo2, { as: "h1", marginBottom: "oneAndHalf" }, title), /* @__PURE__ */ React6.createElement(BodyTwo, { marginBottom: "oneAndHalf" }, disclaimer), /* @__PURE__ */ React6.createElement(Box5, { as: "ul", marginBottom: "oneAndHalf" }, menuItems.map(({ id, title: itemTitle, url, detailPage }) => {
    const isExternalLink = isAbsoluteUrl2(url);
    return /* @__PURE__ */ React6.createElement("li", { key: id }, /* @__PURE__ */ React6.createElement(
      TopicItemLink,
      {
        isExternalLink,
        url: !isExternalLink && detailPage ? getLinkToModalParam(id) : url,
        onClick: () => {
          dispatchTopicItemAnalytics(itemTitle);
        },
        itemTitle
      }
    ));
  })), /* @__PURE__ */ React6.createElement(SubtitleOne2, { as: "h2", marginBottom: "oneAndHalf" }, footerText), /* @__PURE__ */ React6.createElement(
    PrimaryButton,
    {
      as: "a",
      textDecoration: "none",
      href: footerUrl,
      onClick: () => {
        sendAnalyticsEvent2({
          category: "Quick Action Detail",
          action: "Footer Action Button",
          label: footerActionText
        });
      }
    },
    footerActionText
  ));
};

// src/hooks/use-get-care-triage.hook.ts
import { useCallback } from "react";
import { useModalA11yProps } from "@leagueplatform/ui-kit";
import { useIntl as useIntl3 } from "@leagueplatform/locales";

// src/hooks/use-quick-actions.hook.ts
import { useQuery } from "@tanstack/react-query";
import camelcaseKeys from "camelcase-keys";
import {
  getQuickActions,
  GET_QUICK_ACTIONS_MESSAGE_TYPE
} from "@leagueplatform/care-discovery-api";

// src/utils/set-is-external.ts
import { parseUrl } from "@leagueplatform/web-common";
var hasUrl = (actionItem) => Boolean(actionItem.url);
var addIsExternal = (_a) => {
  var _b = _a, { url } = _b, actionItem = __objRest(_b, ["url"]);
  return __spreadProps(__spreadValues({}, actionItem), {
    url,
    isExternal: window.location.hostname !== parseUrl(url).hostname
  });
};
var setIsExternal = (items) => items.filter(hasUrl).map(addIsExternal);

// src/hooks/use-quick-actions.hook.ts
var useQuickActions = (version) => {
  const { data, isLoading, isError, isSuccess } = useQuery(
    [GET_QUICK_ACTIONS_MESSAGE_TYPE, version],
    () => getQuickActions(version)
  );
  const quickActionsData = camelcaseKeys(data == null ? void 0 : data.quick_actions_main_page, {
    deep: true
  });
  return {
    actionItems: (quickActionsData == null ? void 0 : quickActionsData.actionItems) ? setIsExternal(quickActionsData.actionItems) : [],
    menuItems: (quickActionsData == null ? void 0 : quickActionsData.menuItems) || [],
    isLoading,
    isError,
    isSuccess
  };
};

// src/hooks/use-get-care-triage.hook.ts
var useGetCareTriage = (version) => {
  var _a;
  const { formatMessage } = useIntl3();
  const { matchModalPath, closeModal, linkToModalParam } = useModalParam();
  const { isLoading, actionItems, menuItems } = useQuickActions(version);
  const modalAriaProps = useModalA11yProps(
    formatMessage({ id: "GET_CARE" })
  );
  const focusRef = useCallback((node) => {
    var _a2;
    return (_a2 = node == null ? void 0 : node.focus) == null ? void 0 : _a2.call(node);
  }, []);
  const isOpen = Boolean(matchModalPath("get-care"));
  const topicMatch = matchModalPath("get-care/:topicId/:subTopicId?");
  const {
    topicId,
    subTopicId
  } = (topicMatch == null ? void 0 : topicMatch.params) || {};
  let topic;
  let topicMenuItems;
  let backButtonUrl;
  if (topicId && (menuItems == null ? void 0 : menuItems.length)) {
    topic = menuItems == null ? void 0 : menuItems.find((item) => item.id === topicId);
    backButtonUrl = linkToModalParam("get-care");
    topicMenuItems = (_a = topic == null ? void 0 : topic.detailPage) == null ? void 0 : _a.menuItems;
  }
  if (subTopicId) {
    topic = topicMenuItems == null ? void 0 : topicMenuItems.find((item) => item.id === subTopicId);
    backButtonUrl = linkToModalParam(`get-care/${topicId}`);
  }
  const hasBackButton = Boolean(topic);
  return {
    isOpen,
    closeModal,
    isLoading,
    actionItems,
    menuItems,
    modalAriaProps,
    focusRef,
    topic,
    topicId,
    backButtonUrl,
    hasBackButton
  };
};

// src/components/get-care-triage/get-care-triage.component.tsx
var LOADING_HEIGHT_MATCHES_LOADED_CONTENT = "660px";
var CloseButton = forwardRef(({ onClick }, ref) => {
  const { formatMessage } = useIntl4();
  return /* @__PURE__ */ React7.createElement(Box6, { position: "absolute", top: "one", insetInlineEnd: "oneAndHalf" }, /* @__PURE__ */ React7.createElement(
    QuietButton,
    {
      size: "two",
      textDecoration: "none",
      fontSize: "body1",
      paddingX: "none",
      activeStyle: { color: "inherit" },
      onClick,
      ref
    },
    /* @__PURE__ */ React7.createElement(
      Icon2,
      {
        icon: "tinyClose",
        size: "12px",
        label: formatMessage({ id: "CLOSE" })
      }
    )
  ));
});
var BackButtonLink = forwardRef(
  ({ to, children, tabIndex, className, onClick }, ref) => /* @__PURE__ */ React7.createElement(
    Link3,
    {
      className,
      tabIndex,
      ref,
      to,
      onClick
    },
    children
  )
);
var BackButton = forwardRef(
  ({ to, onClick }, ref) => {
    const { formatMessage } = useIntl4();
    return /* @__PURE__ */ React7.createElement(Box6, { position: "absolute", top: "one", insetInlineStart: "oneAndHalf" }, /* @__PURE__ */ React7.createElement(
      QuietButton,
      {
        as: BackButtonLink,
        size: "two",
        textDecoration: "none",
        fontSize: "body1",
        paddingX: "none",
        activeStyle: { color: "inherit" },
        to,
        onClick,
        ref
      },
      /* @__PURE__ */ React7.createElement(
        Icon2,
        {
          icon: "tinyBackButton",
          size: "12px",
          label: formatMessage({ id: "GO_BACK" })
        }
      )
    ));
  }
);
var GetCareTriageComponent = ({
  version
}) => {
  const {
    isOpen,
    closeModal,
    isLoading,
    actionItems,
    menuItems,
    modalAriaProps,
    focusRef,
    topic,
    topicId,
    backButtonUrl,
    hasBackButton
  } = useGetCareTriage(version);
  const { formatMessage } = useIntl4();
  if (!isOpen)
    return null;
  const {
    "aria-label": ariaLabel,
    "aria-modal": ariaModal,
    role
  } = modalAriaProps;
  let content;
  if (isLoading) {
    content = /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(SkeletonBox, { height: "32px", marginBottom: "oneAndHalf" }), /* @__PURE__ */ React7.createElement(SkeletonCards, { numCards: 3, height: "84px", marginBottom: "three" }), /* @__PURE__ */ React7.createElement(SkeletonBox, { height: "78px", marginTop: "one" }), /* @__PURE__ */ React7.createElement(SkeletonBox, { height: "78px", marginTop: "one" }), /* @__PURE__ */ React7.createElement(SkeletonBox, { height: "78px", marginTop: "one" }), /* @__PURE__ */ React7.createElement(SkeletonBox, { height: "78px", marginTop: "one" }));
  } else if (topic) {
    const { title, detailPage } = topic;
    const {
      title: detailPageTitle,
      disclaimer,
      menuItems: detailPageMenuItems,
      footerText,
      footerActionText,
      footerUrl
    } = detailPage;
    content = /* @__PURE__ */ React7.createElement(
      TopicScreen,
      {
        topic: title,
        parentTopicId: topicId,
        title: detailPageTitle,
        disclaimer,
        menuItems: detailPageMenuItems,
        footerText,
        footerActionText,
        footerUrl
      }
    );
  } else {
    content = /* @__PURE__ */ React7.createElement(TriageScreen, { actionItems, menuItems });
  }
  return /* @__PURE__ */ React7.createElement(Modal.Wrapper, { onClose: closeModal, options: {} }, /* @__PURE__ */ React7.createElement(
    Box6,
    {
      backgroundColor: "surface.background.primary",
      borderRadius: "medium",
      height: isLoading ? LOADING_HEIGHT_MATCHES_LOADED_CONTENT : "auto",
      maxHeight: "70%",
      overflowX: "auto",
      position: "relative",
      width: 480,
      "aria-label": ariaLabel,
      "aria-modal": ariaModal,
      role
    },
    hasBackButton ? /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(
      BackButton,
      {
        to: backButtonUrl,
        ref: focusRef,
        onClick: () => {
          sendAnalyticsEvent3({
            category: "Quick Action Detail",
            action: "Back To Quick Action Menu",
            label: formatMessage({ id: "GO_BACK" })
          });
        }
      }
    ), /* @__PURE__ */ React7.createElement(
      CloseButton,
      {
        onClick: () => {
          sendAnalyticsEvent3({
            category: "Quick Action Detail",
            action: "Close",
            label: formatMessage({ id: "CLOSE" })
          });
          closeModal();
        }
      }
    )) : /* @__PURE__ */ React7.createElement(
      CloseButton,
      {
        ref: focusRef,
        onClick: () => {
          sendAnalyticsEvent3({
            category: "Quick Action Menu",
            action: "Close",
            label: formatMessage({ id: "CLOSE" })
          });
          closeModal();
        }
      }
    ),
    /* @__PURE__ */ React7.createElement(Box6, { padding: "two", paddingTop: "four" }, content)
  ));
};

// src/components/get-assistance-now/get-assistance-now.component.tsx
import React9 from "react";
import {
  BodyOne as BodyOne2,
  css,
  genesisStyled,
  HeadingTwo as HeadingTwo3
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { StackLayout as StackLayout3 } from "@leagueplatform/web-common-components";

// src/components/provider-card/provider-card.component.tsx
import React8 from "react";
import {
  BodyOne,
  Box as Box7,
  Flex as Flex2,
  HeadingThree,
  PrimaryButton as PrimaryButton2,
  SubtitleOne as SubtitleOne3,
  useTheme as useTheme2
} from "@leagueplatform/genesis-commons";
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SCREEN_NAMES,
  trackAnalyticsEvent
} from "@leagueplatform/analytics";
import { CardBanner, StackLayout as StackLayout2 } from "@leagueplatform/web-common-components";
import { formatPhoneNumber, normalizeUrl } from "@leagueplatform/web-common";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { useUnknownConfigProperty } from "@leagueplatform/core";

// src/care-discovery.config.ts
import { useConfigProperty } from "@leagueplatform/core";
var defaultConfig = {
  showGetAssistanceNowSubheading: false,
  showProviderAvailability: false
};
var useCareDiscoveryConfig = () => useConfigProperty("careDiscovery", defaultConfig);

// src/components/provider-card/provider-card.component.tsx
var getCardBannerStyles = ({ breakpoints }) => ({
  imageContainer: {
    minHeight: "56px",
    width: "56px",
    borderRadius: "medium",
    alignSelf: "center",
    flexShrink: "0",
    margin: "one",
    marginInlineEnd: "none",
    "&&": {
      [`@media screen and (min-width: ${breakpoints.phone})`]: {
        margin: "two",
        height: "136px",
        maxWidth: "136px",
        borderInlineStartStyle: "none"
      }
    }
  },
  wrapper: {
    flexDirection: "row-reverse",
    alignItems: "center"
  }
});
var trackAnalytics = (title) => {
  trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
    product_area: PRODUCT_AREA.GET_CARE,
    sub_product_area: SCREEN_NAMES.HOMEPAGE,
    screen_name: SCREEN_NAMES.HOMEPAGE,
    detail: "connect with care team",
    sub_detail: title.toLowerCase()
  });
};
var AvailabilityBanner = ({ text }) => /* @__PURE__ */ React8.createElement(
  Flex2,
  {
    width: "fit-content",
    justifyContent: "center",
    alignItems: "center",
    paddingY: "quarter",
    paddingX: "half",
    borderRadius: "pill",
    backgroundColor: "highlight.background.subdued"
  },
  /* @__PURE__ */ React8.createElement(
    Box7,
    {
      width: "10px",
      height: "10px",
      backgroundColor: "highlight.icon",
      borderRadius: "circle",
      marginInlineEnd: "quarter"
    }
  ),
  /* @__PURE__ */ React8.createElement(BodyOne, { fontSize: "overline" }, text)
);
var ProviderCard = ({
  url,
  title,
  description,
  image,
  phoneNumber,
  availabilityText
}) => {
  const { formatMessage } = useIntl5();
  const { showProviderAvailability } = useCareDiscoveryConfig();
  const theme = useTheme2();
  const adjustForCardColorThemeDiscrepancy = useUnknownConfigProperty(
    "__care__adjustForCardColorThemeDiscrepancy"
  );
  return /* @__PURE__ */ React8.createElement(
    CardBanner,
    {
      url: phoneNumber ? void 0 : normalizeUrl(url),
      image,
      styles: getCardBannerStyles(theme),
      backgroundColor: adjustForCardColorThemeDiscrepancy ? "surface.card.primary" : "surface.card.secondary",
      onClick: () => trackAnalytics(title)
    },
    /* @__PURE__ */ React8.createElement(StackLayout2, { space: "$half" }, showProviderAvailability && availabilityText && /* @__PURE__ */ React8.createElement(AvailabilityBanner, { text: availabilityText }), /* @__PURE__ */ React8.createElement(HeadingThree, null, title), /* @__PURE__ */ React8.createElement(BodyOne, { color: "onSurface.text.subdued" }, description), phoneNumber ? /* @__PURE__ */ React8.createElement(SubtitleOne3, { as: "h4" }, formatPhoneNumber(phoneNumber)) : /* @__PURE__ */ React8.createElement(PrimaryButton2, null, formatMessage({ id: "START_A_VISIT" })))
  );
};

// src/components/get-assistance-now/get-assistance-now.component.tsx
var StyledListItem = genesisStyled("li")(
  css({
    marginBottom: "oneAndHalf"
  })
);
var GetAssistanceNow = ({ careProviders }) => {
  const { formatMessage } = useIntl6();
  const { showGetAssistanceNowSubheading } = useCareDiscoveryConfig();
  return /* @__PURE__ */ React9.createElement(StackLayout3, { space: "$oneAndHalf" }, /* @__PURE__ */ React9.createElement(HeadingTwo3, null, formatMessage({ id: "GET_ASSISTANCE_NOW" })), showGetAssistanceNowSubheading && /* @__PURE__ */ React9.createElement(BodyOne2, { color: "onSurface.text.subdued" }, formatMessage({ id: "GET_ASSISTANCE_NOW_SUBHEADING" })), /* @__PURE__ */ React9.createElement("ul", null, careProviders.map((careProvider) => {
    const {
      title,
      description,
      url,
      iconUrl,
      phoneNumber,
      availabilityText
    } = careProvider.attributes;
    return /* @__PURE__ */ React9.createElement(StyledListItem, { key: careProvider.id }, /* @__PURE__ */ React9.createElement(
      ProviderCard,
      {
        title,
        description,
        url,
        image: iconUrl,
        phoneNumber,
        availabilityText
      }
    ));
  })));
};

// src/care-discovery.routes.tsx
import React15 from "react";
import { Routes, Route } from "@leagueplatform/routing";
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
import { LoadingIndicator as LoadingIndicator3 } from "@leagueplatform/web-common-components";
import { getModulePath as getModulePath2, LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2 } from "@leagueplatform/core";

// src/pages/masonry-get-care-landing/masonry-get-care-landing.page.tsx
import React10 from "react";
import Masonry, {
  getMasonryDriver,
  getMasonryWSDriver
} from "@leagueplatform/masonry";
import { CarePageWrapper } from "@leagueplatform/care-common";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import {
  usePageViewAnalytics,
  PRODUCT_AREA as PRODUCT_AREA2,
  SCREEN_NAMES as SCREEN_NAMES2
} from "@leagueplatform/analytics";
import { MasonryEngine } from "@leagueplatform/masonry-engine";
import { useDocumentTitle } from "@leagueplatform/web-common";
import {
  Responsive,
  StackLayout as StackLayout4,
  Box as Box8,
  HeadingText as HeadingText2
} from "@leagueplatform/genesis-core";
import { PageContainer } from "@leagueplatform/web-common-components";
import { getScopedCssClassnames } from "@leagueplatform/ui-kit";
var masonryConfig = {
  apiVersion: 1,
  productArea: PRODUCT_AREA2.GET_CARE,
  screenName: SCREEN_NAMES2.HOMEPAGE
};
var GetCareMasonryLayoutWrapper = ({
  RightColumn,
  LeftColumn
}) => RightColumn ? /* @__PURE__ */ React10.createElement(React10.Fragment, null, /* @__PURE__ */ React10.createElement(Responsive, { down: "tablet" }, /* @__PURE__ */ React10.createElement(StackLayout4, { spacing: "$two" }, /* @__PURE__ */ React10.createElement(Box8, { css: { width: "100%" } }, RightColumn), /* @__PURE__ */ React10.createElement(Box8, { css: { width: "100%" } }, LeftColumn))), /* @__PURE__ */ React10.createElement(Responsive, { up: "tablet" }, /* @__PURE__ */ React10.createElement(StackLayout4, { orientation: "horizontal", spacing: "$two" }, /* @__PURE__ */ React10.createElement(
  Box8,
  {
    css: {
      width: "70%",
      "@tablet": { width: "60%" }
    }
  },
  LeftColumn
), /* @__PURE__ */ React10.createElement(
  Box8,
  {
    css: {
      width: "30%",
      "@tablet": { width: "40%" }
    }
  },
  RightColumn
)))) : React10.createElement(React10.Fragment, null, LeftColumn);
var DefaultMasonryContainer = ({
  masonryAppId
}) => {
  const LeftColumn = React10.useMemo(
    () => Masonry.init(__spreadProps(__spreadValues({}, {
      apiVersion: masonryConfig.apiVersion,
      analytics: {
        productArea: masonryConfig.productArea,
        screenName: masonryConfig.screenName
      }
    }), {
      appId: masonryAppId.left,
      apiParams: {
        platform: "web"
      }
    })),
    [masonryAppId.left]
  );
  const RightColumn = React10.useMemo(() => {
    if (masonryAppId.right) {
      return Masonry.init(__spreadProps(__spreadValues({}, {
        apiVersion: masonryConfig.apiVersion,
        analytics: {
          productArea: masonryConfig.productArea,
          screenName: masonryConfig.screenName
        }
      }), {
        appId: masonryAppId.right
      }));
    }
    return void 0;
  }, [masonryAppId.right]);
  return /* @__PURE__ */ React10.createElement(
    GetCareMasonryLayoutWrapper,
    {
      RightColumn: RightColumn && /* @__PURE__ */ React10.createElement(RightColumn.Provider, null),
      LeftColumn: /* @__PURE__ */ React10.createElement(LeftColumn.Provider, null)
    }
  );
};
var MasonryV1Container = ({
  masonryAppId
}) => {
  const LeftColumn = React10.useMemo(
    () => getMasonryWSDriver(__spreadProps(__spreadValues({}, masonryConfig), {
      appId: masonryAppId.left,
      apiParams: {
        platform: "web"
      }
    })),
    [masonryAppId.left]
  );
  const RightColumn = React10.useMemo(() => {
    if (masonryAppId.right) {
      return getMasonryWSDriver(__spreadProps(__spreadValues({}, masonryConfig), {
        appId: masonryAppId.right
      }));
    }
    return void 0;
  }, [masonryAppId.right]);
  return /* @__PURE__ */ React10.createElement(
    GetCareMasonryLayoutWrapper,
    {
      RightColumn: RightColumn && /* @__PURE__ */ React10.createElement(MasonryEngine, { driver: RightColumn }),
      LeftColumn: /* @__PURE__ */ React10.createElement(MasonryEngine, { driver: LeftColumn })
    }
  );
};
var MasonryV2Container = ({
  masonryAppId
}) => {
  const MasonryOverviewDriver = getMasonryDriver({
    rootNodeId: masonryAppId.left
  });
  return /* @__PURE__ */ React10.createElement(MasonryEngine, { driver: MasonryOverviewDriver });
};
var MasonryGetCareLandingPage = () => {
  const { formatMessage } = useIntl7();
  usePageViewAnalytics({
    product_area: PRODUCT_AREA2.GET_CARE,
    sub_product_area: SCREEN_NAMES2.HOMEPAGE,
    screen_name: SCREEN_NAMES2.HOMEPAGE
  });
  useDocumentTitle(formatMessage({ id: "GET_CARE" }));
  const defaultMasonryAppId = { left: "", right: "" };
  const { masonryAppId = defaultMasonryAppId, masonryAppVersion } = useCareDiscoveryConfig();
  switch (masonryAppVersion) {
    case "2.0":
      return /* @__PURE__ */ React10.createElement(
        PageContainer,
        {
          className: getScopedCssClassnames(),
          css: {
            "@mobile": {
              paddingInline: "$oneAndHalf"
            }
          }
        },
        /* @__PURE__ */ React10.createElement(
          StackLayout4,
          {
            css: {
              marginTop: "$four",
              marginBottom: "$four",
              "@mobile": {
                marginTop: "$three",
                marginBottom: "$three"
              }
            },
            spacing: "$twoAndHalf",
            horizontalAlignment: "stretch"
          },
          /* @__PURE__ */ React10.createElement(HeadingText2, { size: "xxl", level: "1" }, formatMessage({ id: "GET_CARE" })),
          /* @__PURE__ */ React10.createElement(MasonryV2Container, { masonryAppId })
        )
      );
    case "1.5":
      return /* @__PURE__ */ React10.createElement(CarePageWrapper, { title: formatMessage({ id: "GET_CARE" }) }, /* @__PURE__ */ React10.createElement(MasonryV1Container, { masonryAppId }));
    default:
      return /* @__PURE__ */ React10.createElement(CarePageWrapper, { title: formatMessage({ id: "GET_CARE" }) }, /* @__PURE__ */ React10.createElement(DefaultMasonryContainer, { masonryAppId }));
  }
};

// src/pages/get-care-landing/get-care-landing.page.tsx
import React13 from "react";
import {
  css as css2,
  Flex as Flex5,
  genesisStyled as genesisStyled2,
  HeadingTwo as HeadingTwo4
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl9 } from "@leagueplatform/locales";
import { useDocumentTitle as useDocumentTitle2 } from "@leagueplatform/web-common";
import {
  LoadingIndicator,
  ErrorState
} from "@leagueplatform/web-common-components";
import {
  usePageViewAnalytics as usePageViewAnalytics2,
  PRODUCT_AREA as PRODUCT_AREA3,
  SCREEN_NAMES as SCREEN_NAMES3,
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME2
} from "@leagueplatform/analytics";
import { CarePageWrapper as CarePageWrapper2 } from "@leagueplatform/care-common";

// src/hooks/use-get-care-landing.hook.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
import {
  getQuickActionsRest,
  getCareProviders
} from "@leagueplatform/care-discovery-api";
import { CARE_TEAM } from "@leagueplatform/care-team";
import { getCareTeam } from "@leagueplatform/care-team-api";
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";
var useGetCareLanding = () => {
  const {
    data: dataQuickActions,
    isLoading: isLoadingQuickActions,
    isError: isErrorQuickActions,
    isSuccess: isSuccessQuickActions,
    error: errorQuickActions
  } = useQuery2(
    ["GET_QUICK_ACTIONS"],
    () => getQuickActionsRest()
  );
  const {
    data: dataCareProviders,
    isLoading: isLoadingCareProviders,
    isError: isErrorCareProviders,
    isSuccess: isSuccessCareProviders,
    error: errorCareProvider
  } = useQuery2(
    ["GET_CARE_PROVIDERS"],
    () => getCareProviders()
  );
  const { data: careTeamFlag, isLoading: isLoadingCareTeamFlag } = useFeatureFlagQuery(CARE_TEAM);
  const { data: dataCareTeam, isInitialLoading: isLoadingCareTeam } = useQuery2(
    ["GET_CARE_TEAM"],
    () => getCareTeam(),
    {
      enabled: !!careTeamFlag
      // only call if Care Team is enabled for the app
    }
  );
  return {
    isLoading: isLoadingQuickActions || isLoadingCareProviders || isLoadingCareTeam || !!isLoadingCareTeamFlag,
    isError: isErrorQuickActions || isErrorCareProviders,
    isSuccess: isSuccessQuickActions && isSuccessCareProviders,
    error: [errorQuickActions, errorCareProvider],
    data: {
      quickActions: (dataQuickActions == null ? void 0 : dataQuickActions.data) || [],
      careProviders: (dataCareProviders == null ? void 0 : dataCareProviders.data) || [],
      careTeam: dataCareTeam == null ? void 0 : dataCareTeam.data
    }
  };
};

// src/components/quick-action-menu-item/quick-action-menu-item.component.tsx
import React11 from "react";
import {
  HeadingThree as HeadingThree2,
  Image,
  Flex as Flex3,
  BodyTwoSecondary
} from "@leagueplatform/genesis-commons";
import { styled, Icon as Icon3 } from "@leagueplatform/genesis-core";
import { isAbsoluteUrl as isAbsoluteUrl3, normalizeUrl as normalizeUrl2 } from "@leagueplatform/web-common";
import {
  OpensInANewTabMessage,
  InternalOrExternalLink
} from "@leagueplatform/web-common-components";
import { useConfigProperty as useConfigProperty2 } from "@leagueplatform/core";
var Link4 = styled(InternalOrExternalLink, {
  "&": {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "$oneAndHalf",
    backgroundColor: "$interactiveBackgroundDefault",
    borderWidth: "$thin",
    borderStyle: "solid",
    borderRadius: "$large",
    borderColor: "$onSurfaceBorderSubdued"
  },
  "&:hover": {
    textDecoration: "none",
    backgroundColor: "$interactiveBackgroundHovered"
  },
  "&:focus:before": {
    borderRadius: "$large"
  }
});
var QuickActionMenuItem = ({
  title,
  icon,
  url,
  description,
  analyticsEvent
}) => {
  const isExternalUrl = isAbsoluteUrl3(url);
  const handleLinkCallback = useConfigProperty2("core.customMethods.handleLink");
  return /* @__PURE__ */ React11.createElement(
    Link4,
    {
      href: normalizeUrl2(url),
      isExternalUrl,
      onClick: (e) => {
        analyticsEvent();
        if (isExternalUrl) {
          e.preventDefault();
          handleLinkCallback(url);
        }
      }
    },
    icon && /* @__PURE__ */ React11.createElement(Image, { src: icon, alt: "", maxWidth: "56px", marginInlineEnd: "one" }),
    /* @__PURE__ */ React11.createElement(Flex3, { width: "100%", marginInlineEnd: "one", flexDirection: "column" }, /* @__PURE__ */ React11.createElement(HeadingThree2, { width: "100%", color: "onSurface.text.primary" }, title), description && /* @__PURE__ */ React11.createElement(BodyTwoSecondary, { width: "100%", marginTop: "quarter" }, description)),
    isExternalUrl && /* @__PURE__ */ React11.createElement(OpensInANewTabMessage, null),
    /* @__PURE__ */ React11.createElement(Icon3, { icon: "interfaceChevronForward" })
  );
};

// src/components/care-team-card/care-team-card.component.tsx
import * as React12 from "react";
import {
  BodyTwo as BodyTwo2,
  Flex as Flex4,
  Link as Link5,
  PrimaryButton as PrimaryButton3,
  SubtitleOne as SubtitleOne4
} from "@leagueplatform/genesis-commons";
import { Avatar } from "@leagueplatform/web-common-components";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { MESSAGING_LINKS } from "@leagueplatform/messaging";
var CareTeamCard = ({ teamInfo }) => {
  var _a;
  const { formatMessage } = useIntl8();
  const { member } = teamInfo[0];
  const phoneNumber = member.contactPoint.find(
    (contact) => contact.system === "phone"
  );
  const extensionNumber = member.contactPoint.find(
    (contact) => contact.system === "extension"
  );
  const careAdvisorPlaceholderImage = handleStaticAsset(
    "CARE_ADVISOR_IMAGE" /* CARE_ADVISOR_IMAGE */
  );
  return /* @__PURE__ */ React12.createElement(
    Flex4,
    {
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "surface.card.primary",
      borderRadius: "extraLarge",
      paddingY: "two",
      paddingX: "one",
      textAlign: "center"
    },
    /* @__PURE__ */ React12.createElement(
      Avatar,
      {
        imageSrc: (_a = member.photo) != null ? _a : careAdvisorPlaceholderImage,
        userInitials: "",
        marginBottom: "half"
      }
    ),
    /* @__PURE__ */ React12.createElement(SubtitleOne4, { marginBottom: "one" }, member.name),
    /* @__PURE__ */ React12.createElement(BodyTwo2, { marginBottom: "oneAndHalf" }, member.bio),
    /* @__PURE__ */ React12.createElement(
      PrimaryButton3,
      {
        as: Link5,
        href: MESSAGING_LINKS.getStartNewMessage(),
        width: "100%"
      },
      formatMessage({ id: "SEND_NEW_MESSAGE" })
    ),
    (phoneNumber == null ? void 0 : phoneNumber.value) && /* @__PURE__ */ React12.createElement(BodyTwo2, { marginTop: "one" }, formatMessage(
      { id: "OR_CALL_PHONE" },
      {
        phoneNumber: phoneNumber == null ? void 0 : phoneNumber.value,
        extension: (extensionNumber == null ? void 0 : extensionNumber.value) ? `(ext. ${extensionNumber.value})` : ""
      }
    ))
  );
};

// src/pages/get-care-landing/get-care-landing.page.tsx
var StyledList = genesisStyled2("ul")(
  css2({
    "> li:not(:last-child)": {
      marginBottom: "oneAndHalf"
    }
  })
);
var GetCareLandingPage = () => {
  var _a;
  const { formatMessage } = useIntl9();
  usePageViewAnalytics2({
    product_area: PRODUCT_AREA3.GET_CARE,
    sub_product_area: SCREEN_NAMES3.HOMEPAGE,
    screen_name: SCREEN_NAMES3.HOMEPAGE
  });
  useDocumentTitle2(formatMessage({ id: "GET_CARE" }));
  const { isLoading, isError, data, error } = useGetCareLanding();
  if (isLoading) {
    return /* @__PURE__ */ React13.createElement(LoadingIndicator, null);
  }
  if (isError) {
    return /* @__PURE__ */ React13.createElement(CarePageWrapper2, null, /* @__PURE__ */ React13.createElement(ErrorState, { error }));
  }
  const { quickActions, careProviders, careTeam } = data;
  return /* @__PURE__ */ React13.createElement(CarePageWrapper2, { title: formatMessage({ id: "GET_CARE" }) }, /* @__PURE__ */ React13.createElement(
    Flex5,
    {
      flexDirection: { _: "column-reverse", phone: "row" },
      marginBottom: { _: "twoAndHalf", phone: "five" }
    },
    /* @__PURE__ */ React13.createElement(Flex5, { flexGrow: 1, flexDirection: "column" }, /* @__PURE__ */ React13.createElement(HeadingTwo4, { marginBottom: "oneAndHalf" }, formatMessage({ id: "HOW_CAN_WE_HELP" })), /* @__PURE__ */ React13.createElement(StyledList, null, quickActions.map((quickAction) => {
      const { id } = quickAction;
      const { title, url, icon, description } = quickAction.attributes;
      return /* @__PURE__ */ React13.createElement("li", { key: id }, /* @__PURE__ */ React13.createElement(
        QuickActionMenuItem,
        {
          title,
          url,
          icon,
          description,
          analyticsEvent: () => trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
            product_area: PRODUCT_AREA3.GET_CARE,
            sub_product_area: SCREEN_NAMES3.HOMEPAGE,
            screen_name: SCREEN_NAMES3.HOMEPAGE,
            detail: "care menu",
            sub_detail: title.toLowerCase()
          })
        }
      ));
    }))),
    careTeam && /* @__PURE__ */ React13.createElement(
      Flex5,
      {
        marginInlineStart: { _: "none", phone: "twoAndHalf" },
        marginBottom: { _: "twoAndHalf", phone: "none" },
        flexDirection: "column",
        width: { _: "auto", phone: 327 }
      },
      /* @__PURE__ */ React13.createElement(HeadingTwo4, { marginBottom: "oneAndHalf" }, formatMessage({ id: "YOUR_CARE_ADVISOR" })),
      /* @__PURE__ */ React13.createElement(CareTeamCard, { teamInfo: (_a = careTeam == null ? void 0 : careTeam.attributes) == null ? void 0 : _a.participant })
    )
  ), careProviders.length > 0 && /* @__PURE__ */ React13.createElement(GetAssistanceNow, { careProviders }));
};

// src/pages/quick-action/quick-action.page.tsx
import React14 from "react";
import { Box as Box9, css as css3, genesisStyled as genesisStyled3 } from "@leagueplatform/genesis-commons";
import { useDocumentTitle as useDocumentTitle3 } from "@leagueplatform/web-common";
import {
  LoadingIndicator as LoadingIndicator2,
  ErrorState as ErrorState2
} from "@leagueplatform/web-common-components";
import {
  usePageViewAnalytics as usePageViewAnalytics3,
  PRODUCT_AREA as PRODUCT_AREA4,
  SCREEN_NAMES as SCREEN_NAMES4,
  trackAnalyticsEvent as trackAnalyticsEvent3,
  EVENT_NAME as EVENT_NAME3,
  SUB_PRODUCT_AREA
} from "@leagueplatform/analytics";
import { getModulePath, LEAGUE_MODULE_NAMES } from "@leagueplatform/core";
import { CarePageWrapper as CarePageWrapper3 } from "@leagueplatform/care-common";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
import { useParamsLegacy as useParams } from "@leagueplatform/routing";

// src/hooks/use-quick-action.hook.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import {
  getQuickActionRest,
  QUICK_ACTIONS_TYPE
} from "@leagueplatform/care-discovery-api";
var useQuickAction = (quickActionId) => {
  var _a;
  const { data, isLoading, isError, isSuccess, error } = useQuery3(
    ["GET_QUICK_ACTIONS", quickActionId],
    () => getQuickActionRest(quickActionId)
  );
  const quickActionParent = (_a = data == null ? void 0 : data.included) == null ? void 0 : _a.find(
    (quickAction) => quickAction.type === QUICK_ACTIONS_TYPE.quickActionsParent
  );
  return {
    submenuItems: data == null ? void 0 : data.data,
    parent: quickActionParent,
    isLoading,
    isError,
    isSuccess,
    error
  };
};

// src/pages/quick-action/quick-action.page.tsx
var StyledListItem2 = genesisStyled3("li")(
  css3({
    marginBottom: "oneAndHalf"
  })
);
var QuickActionPage = () => {
  const { formatMessage } = useIntl10();
  const { quickActionId } = useParams();
  const screenName = `${SCREEN_NAMES4.QUICK_ACTION_DETAIL} - ${quickActionId}`;
  usePageViewAnalytics3({
    product_area: PRODUCT_AREA4.GET_CARE,
    sub_product_area: screenName,
    screen_name: screenName
  });
  const { isLoading, isError, submenuItems, parent, error } = useQuickAction(
    quickActionId
  );
  useDocumentTitle3(
    `${formatMessage({ id: "GET_CARE" })}${(parent == null ? void 0 : parent.attributes.title) ? ` - ${parent == null ? void 0 : parent.attributes.title}` : ""}`
  );
  if (isLoading) {
    return /* @__PURE__ */ React14.createElement(LoadingIndicator2, null);
  }
  if (isError) {
    return /* @__PURE__ */ React14.createElement(CarePageWrapper3, null, /* @__PURE__ */ React14.createElement(ErrorState2, { error }));
  }
  return /* @__PURE__ */ React14.createElement(
    CarePageWrapper3,
    {
      title: parent == null ? void 0 : parent.attributes.title,
      backButtonPath: getModulePath(LEAGUE_MODULE_NAMES.careDiscovery)
    },
    /* @__PURE__ */ React14.createElement(Box9, null, /* @__PURE__ */ React14.createElement("ul", null, submenuItems == null ? void 0 : submenuItems.map((submenuItem) => {
      const { id } = submenuItem;
      const { title, url } = submenuItem.attributes;
      return /* @__PURE__ */ React14.createElement(StyledListItem2, { key: id }, /* @__PURE__ */ React14.createElement(
        QuickActionMenuItem,
        {
          title,
          url,
          analyticsEvent: () => {
            trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
              product_area: PRODUCT_AREA4.GET_CARE,
              sub_product_area: screenName,
              screen_name: screenName,
              detail: "quick action menu",
              sub_detail: title.toLowerCase()
            });
            if (title.toLowerCase() === "documents") {
              trackAnalyticsEvent3(EVENT_NAME3.BUTTON_CLICKED, {
                product_area: PRODUCT_AREA4.GET_CARE,
                sub_product_area: SUB_PRODUCT_AREA.DOCUMENTS,
                screen_name: PRODUCT_AREA4.GET_CARE
              });
            }
          }
        }
      ));
    })))
  );
};

// src/care-discovery.routes.tsx
var LandingPage = () => {
  var _a;
  const { data: isMasonryDisabled, isLoading } = useFeatureFlagQuery2(
    "disable_care_masonry_page"
  );
  const hasMasonryId = !!((_a = useCareDiscoveryConfig().masonryAppId) == null ? void 0 : _a.left);
  if (isLoading) {
    return /* @__PURE__ */ React15.createElement(LoadingIndicator3, null);
  }
  return hasMasonryId && !isMasonryDisabled ? /* @__PURE__ */ React15.createElement(MasonryGetCareLandingPage, null) : /* @__PURE__ */ React15.createElement(GetCareLandingPage, null);
};
var CareDiscoveryRoutes = () => /* @__PURE__ */ React15.createElement(Routes, null, /* @__PURE__ */ React15.createElement(Route, { index: true, element: /* @__PURE__ */ React15.createElement(LandingPage, null) }), /* @__PURE__ */ React15.createElement(
  Route,
  {
    path: "submenu/benefits-and-coverage/:quickActionId/*",
    element: /* @__PURE__ */ React15.createElement(QuickActionPage, null)
  }
));
var CareDiscoveryRoutesBrowserRouter = [
  {
    path: getModulePath2(LEAGUE_MODULE_NAMES2.careDiscovery),
    element: /* @__PURE__ */ React15.createElement(LandingPage, null)
  },
  {
    path: `${getModulePath2(
      LEAGUE_MODULE_NAMES2.careDiscovery
    )}/submenu/benefits-and-coverage/:quickActionId`,
    element: /* @__PURE__ */ React15.createElement(QuickActionPage, null)
  }
];

// src/hooks/use-is-care-discovery-enabled.hook.ts
import { useFeatureFlagQuery as useFeatureFlagQuery3 } from "@leagueplatform/user-profile-api";
var useIsCareDiscoveryEnabled = () => {
  const { data, isLoading } = useFeatureFlagQuery3("care_discovery_enabled");
  return data || isLoading;
};

// src/index.tsx
initModule();
initMasonryRegistry();
export {
  CareDiscoveryRoutes,
  CareDiscoveryRoutesBrowserRouter,
  GetAssistanceNow,
  GetCareTriageComponent,
  useIsCareDiscoveryEnabled
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/care-discovery'] = window.leagueSDKsPresent['@leagueplatform/care-discovery'] || [];
    window.leagueSDKsPresent['@leagueplatform/care-discovery'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/care-discovery'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/care-discovery module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map